export default __webpack_public_path__ + "static/media/marauders-map-v5.1-03-00.dac85db1.jpg";